// Breakpoint constants for consistent responsive design
export const BREAKPOINTS = {
  xs: '375px',   // Mobile
  sm: '640px',   // Small tablets
  md: '768px',   // Tablets
  lg: '1024px',  // Small laptops
  xl: '1280px',  // Laptops
  '2xl': '1536px', // Desktops
  '3xl': '1920px'  // Large screens
};

export const CONTAINER_PADDING = {
  xs: '1rem',
  sm: '2rem',
  md: '3rem',
  lg: '4rem',
  xl: '5rem',
  '2xl': '6rem',
  '3xl': '8rem'
};